import { ComparisonPageTemplate } from "@/components/ComparisonPageTemplate";
import { Brain, Users, Clock } from "lucide-react";

const CSWvsAnki = () => {
  return (
    <ComparisonPageTemplate
      platformName="Anki"
      platformUrl="https://apps.ankiweb.net"
      seoDescription="Compare CSW and Anki flashcard apps. Discover why CSW offers an easier learning curve and better collaborative study features."
      seoKeywords="CSW vs Anki, Anki alternative, free flashcard app, spaced repetition alternative"
      canonicalUrl="https://csw.live/flash-cards/csw-vs-anki/"
      heroDescription="Looking for a simpler alternative to Anki? CSW offers intuitive flashcard creation and collaborative study without the steep learning curve."
      alternativeDescription="While Anki excels at spaced repetition with deep customization, CSW provides an accessible, social learning environment."
      background="Anki is a powerful spaced-repetition flashcard application with deep customization, supporting images, audio, and HTML/CSS."
      pros={[
        { text: "Powerful spaced-repetition algorithm" },
        { text: "Deep customization with HTML/CSS support" },
        { text: "Free and open-source" }
      ]}
      cons={[
        { text: "Steep learning curve for new users" },
        { text: "Card creation can be time-consuming" },
        { text: "No built-in collaborative features" }
      ]}
      cswFeatures={[
        { text: "Easy to Use", available: true },
        { text: "Collaborative Study", available: true },
        { text: "Gamified Learning", available: true },
        { text: "No Learning Curve", available: true }
      ]}
      competitorFeatures={[
        { text: "Easy to Use", available: false },
        { text: "Collaborative Study", available: false },
        { text: "Gamified Learning", available: false },
        { text: "No Learning Curve", available: false }
      ]}
      benefits={[
        { icon: Brain, title: "Instant Start", description: "No complex setup—start studying immediately." },
        { icon: Users, title: "Study Together", description: "Collaborate with classmates in real-time." },
        { icon: Clock, title: "Engaging Experience", description: "Gamified elements keep you motivated." }
      ]}
      forStudentsText="CSW removes Anki's complexity while adding collaborative features. Start immediately without spending hours learning the software."
      pricingText="Both offer free access, but CSW provides a more intuitive experience with built-in collaboration."
      competitorPrice="Free (iOS $24.99)"
    />
  );
};

export default CSWvsAnki;
